import React from 'react';

import { LoadingOverlay, Paper, Stack } from '@mantine/core';
import InvoiceActivityCard from 'components/invoices/InvoiceActivityCard';
import KiloAlert from 'components/KiloAlert';
import { UseQueryResult } from 'react-query';
import { InvoiceRetrieve } from 'types';

type InvoiceActivityTabProps = {
  invoiceQuery: UseQueryResult<{
    data: InvoiceRetrieve;
  }>;
};

const InvoiceActivityTab = ({ invoiceQuery }: InvoiceActivityTabProps): JSX.Element => {
  if (invoiceQuery.isLoading) {
    return <LoadingOverlay visible />;
  }
  if (invoiceQuery.isError) {
    return (
      <KiloAlert title='Error' variantStyle='error' color='red'>
        Something went wrong while fetching data!
      </KiloAlert>
    );
  }
  return (
    <Paper withBorder h='100%' p='md' shadow='sm'>
      <Stack>
        {invoiceQuery.data?.data.invoiceActivity.map(invoiceAction => (
          <InvoiceActivityCard key={invoiceAction.invoiceActionId} invoiceAction={invoiceAction} />
        ))}
      </Stack>
    </Paper>
  );
};

export default InvoiceActivityTab;
